import * as customersApi from '@/network/api/customers/customers.api.js'

/** Changes User Friendly Name
@return { promise }
*/
export const changeUserFriendlyName = async (context, payload) => {
    const res = await customersApi.changeUserFriendlyName(payload)

    return res
}
